import { useState } from "react";

export function Footer(): React.ReactElement {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return (
    <>
      <footer className="flex shrink-0 items-center justify-end gap-3 border-t border-border-subtle bg-surface px-3 py-1 text-[10px] text-text-muted">
        <button
          type="button"
          onClick={() => setShowDisclaimer(true)}
          className="transition-colors hover:text-text-secondary"
        >
          Disclaimer
        </button>
        <a
          href="https://ko-fi.com/pulseforge"
          target="_blank"
          rel="noreferrer noopener"
          className="rounded border border-border-subtle px-2 py-0.5 transition-colors hover:border-accent hover:text-accent"
        >
          Ko-fi
        </a>
        <a
          href="https://github.com/apollyon-sys/wardogs-calculator/issues"
          target="_blank"
          rel="noreferrer noopener"
          className="transition-colors hover:text-text-secondary"
        >
          Feedback
        </a>
      </footer>

      {showDisclaimer && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
          onClick={() => setShowDisclaimer(false)}
        >
          <div
            className="mx-4 w-full max-w-lg rounded-lg border border-border-strong bg-surface-raised p-6 shadow-2xl"
            onClick={(event) => event.stopPropagation()}
          >
            <h2 className="mb-4 text-sm font-bold tracking-wide text-text-primary">
              Disclaimer
            </h2>

            <div className="space-y-3 text-xs leading-relaxed text-text-secondary">
              <p>
                This is an <strong className="text-text-primary">unofficial fan-made</strong>{" "}
                community tool. It is not affiliated with, endorsed by, or connected to{" "}
                <strong className="text-text-primary">BULKHEAD</strong> or{" "}
                <strong className="text-text-primary">Team17</strong> in any way.
              </p>

              <p>
                All game imagery, map tiles, marker icons and other in-game assets are{" "}
                <strong className="text-text-primary">&copy; BULKHEAD / Team17</strong> and
                remain the property of their respective owners. They are used here in the same
                way other community tools in the WARDOGS ecosystem do.
              </p>

              <p>
                Map calibration, tile data and marker positions are derived from the open-source{" "}
                <a
                  href="https://github.com/apollyon-sys/wardogs-calculator"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-accent underline"
                >
                  WARDOGS Calculator
                </a>{" "}
                by Apollyon (MIT licence). Community place names come from{" "}
                <a
                  href="https://wardogshub.uk"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-accent underline"
                >
                  WARDOGS Hub
                </a>
                .
              </p>

              <p>
                I am just a fan who wanted a command tool that did not exist yet. If you enjoy
                it, consider{" "}
                <a
                  href="https://ko-fi.com/pulseforge"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-accent underline"
                >
                  supporting the project on Ko-fi
                </a>
                .
              </p>
            </div>

            <button
              type="button"
              onClick={() => setShowDisclaimer(false)}
              className="mt-5 w-full rounded bg-accent py-2 text-xs font-semibold text-surface"
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </>
  );
}
